import { IconProps } from '@components/icons/CustomIcons';

export const ArrowTopRightOnSquareIcon = (props?: IconProps) => {
    const { width = 14, height = 14, className } = { ...props };
    return (
        <svg
            className={className}
            width={width}
            height={height}
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M7.875 3.5H3.0625C2.33763 3.5 1.75 4.08763 1.75 4.8125V10.9375C1.75 11.6624 2.33763 12.25 3.0625 12.25H9.1875C9.91237 12.25 10.5 11.6624 10.5 10.9375V6.125M4.375 9.625L12.25 1.75M12.25 1.75L9.1875 1.75M12.25 1.75V4.8125"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default ArrowTopRightOnSquareIcon;
